import { authAPIUrl } from "@/environment";
import { CompanyService } from "@/services/company.service";

import { catched } from "./catched";

export class CompanyHandler {
  constructor() {
    this.companyService = new CompanyService(authAPIUrl);
  }

  async getCompany() {
    return this.companyService.getCompany();
  }

  async getPasswordRules() {
    const result = await catched(this.companyService.getPasswordRules());
    if (result.success && result.data) {
      result.data = {
        minLength: result.data.min_length,
        maxLength: result.data.max_length,
        requireMixedCase: result.data.require_mixed_case,
        requireNonAlpha: result.data.require_non_alpha,
        requireNumber: result.data.require_number,
      };
    }
    return result;
  }

  setTheme(themeName) {
    return catched(this.companyService.setTheme(themeName));
  }

  getTheme() {
    return catched(this.companyService.getTheme());
  }

  async setSSOLoginTheme() {
    return catched(this.companyService.setTheme("pip-theme-sso-only"));
  }

  async setStandardLoginTheme() {
    return catched(this.companyService.setTheme("pip-theme"));
  }

  async ssoOnlyLogin() {
    const theme = await this.getTheme();
    if (!theme.success) return theme;
    return theme.data.name === "pip-theme-sso-only";
  }

  async getCompanySettings() {
    return catched(this.companyService.getSettings());
  }

  async setCompanySettings(settings) {
    const payload = { auto_logout_after: settings.autoLogoutAfter };
    return catched(this.companyService.setSettings(payload));
  }
}
